import { BrowserRouter as Router, Route } from "react-router-dom";
import React, { Component } from "react";
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from "react-toasts";
import AddressPhoneForm from "./pages/addressPhoneForm";
import BreakTheGlassPage from "./pages/breakTheGlassPage";
import Authenticators from "./pages/authenticators";
import Footer from "./components/footer";
import Header from "./components/header";
import HomePage from "./pages/home";
import LoginDigiDPage from "./pages/loginDigiD";
import LoginPage from "./pages/login";
import LoginSmsPage from "./pages/loginSms";
import LogoutPage from "./pages/logout";
import MessagePage from "./pages/message";
import settings from "./client.settings.json";
import LandingPage from "./pages/landingPage";
import "./App.css";

class App extends Component {
  componentDidMount() {
    this.addCss();
  }

  render() {
    const stem = settings.frontend_app_path;

    return (
      <div className="app">
        <Router>
          <Header />
          <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_CENTER} />
          <Route path={`${stem}`} exact component={HomePage} />
          <Route path={`${stem}:tenantId`} exact component={LandingPage} />
          <Route path={`${stem}:tenantId/authenticators/:messageId`} component={Authenticators} />
          <Route path={`${stem}:tenantId/login/:messageId`} component={LoginPage} />
          <Route path={`${stem}:tenantId/loginsms/:messageId`} component={LoginSmsPage} />
          <Route path={`${stem}:tenantId/logindigid/:messageId`} component={LoginDigiDPage} />
          <Route path={`${stem}:tenantId/messages/:messageId`} exact component={MessagePage} />
          <Route path={`${stem}:tenantId/addressess/:addressId/breaktheglass/:messageId`} exact component={BreakTheGlassPage} />
          <Route path={`${stem}:tenantId/addressess/:addressId`} exact component={AddressPhoneForm} />
          <Route path={`${stem}:tenantId/logout`} exact component={LogoutPage} />
          <Footer />
        </Router>
      </div>
    );
  }

  addCss = () => {
    let head = document.head,
      link = document.createElement("link"),
      tenantid = window.location.pathname.replace(settings.frontend_app_path, "").split("/")[0];
    if (tenantid) {
      link.type = "text/css";
      link.rel = "stylesheet";
      link.href = `${settings.api}/style/${tenantid}/style.css`;
      head.appendChild(link);
    }
  };
}

export default App;
